import React, { useState, useEffect, useRef } from 'react';
import Slick from 'react-slick';
import { zeroTransfer } from '../../utils/methods';
import './index.scss';
import LightBox from './Lightbox';

const ImageCarousel = ({ className, data }) => {
  const [images, setImages] = useState(data?.map(url => ({
    url: url.startsWith('/') ? url : `/${url}`,
    vertical: false
  })) || []);
  const [currentIndex, setCurrentIndex] = useState(1);
  const carousel = useRef(null);

  const [currentSelected, setCurrentSelected] = useState(null);

  useEffect(() => {
    getImagesData(data);
  }, []);

  const slickSettings = {
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    afterChange: current => setCurrentIndex(current + 1)
  };

  const getImagesData = (data) => {
    const imagesData = [];
    let count = 0;

    data.forEach((url, i) => {
    //   let obj;
      const imageUrl = url.startsWith('/') ? url : `/${url}`;
      checkImageVertical(imageUrl).then(result => {
        // const image = new Image();
        // image.src = imageUrl;
        // obj = { url: imageUrl, vertical: result };
        // imagesData[i] = obj;

        // count++;
        // count === data.length && setImages(imagesData)
        if (result) {
          setImages(prev => prev.map(image => image.url === imageUrl ? { ...image, vertical: true } : image));
        }
      }).catch((err) => {
        // console.log(err);
      })
    })
  }

  function checkImageVertical(url) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = () => resolve(img.height / img.width >= 1);
      img.onerror = reject;
      img.src = url;
    });
  }

  function handleImageClick(image) {
    setCurrentSelected(image.url);
  }

  return (
    <React.Fragment>
      {
        currentSelected && (
          <LightBox image={currentSelected} onClose={() => setCurrentSelected(null)} />
        )
      }
      <div className="carousel-nav container">
        <button className="prev" onClick={carousel.current && carousel.current.slickPrev}>
          <i className="icon-prev"></i>
          <span className="type-text -en -lg">PREVIOUS</span>
        </button>
        {
          images &&
          <div className="nav">{`${zeroTransfer(currentIndex)} / ${zeroTransfer(images.length)}`}</div>
        }
        <button className="next" onClick={carousel.current && carousel.current.slickNext}>
          <span className="type-text -en -lg">NEXT</span>
          <i className="icon-next"></i>
        </button>
      </div>
      <Slick className={`image-carousel ${className ? className : ''}`} ref={carousel} {...slickSettings}>
        {
          images && images.map((image, i) =>
            <div key={i} className={`item ${image.vertical ? '-vertical' : ''}`} onClick={() => handleImageClick(image)}>
              <div className="wrap"><img className="img" src={`${image.url.startsWith("/") ? "" : "/"}${image.url}`} alt="" /></div>
            </div>
          )
        }
      </Slick>
    </React.Fragment>
  )
}

export default ImageCarousel;
